module.exports = __webpack_public_path__ + "static/media/fanny.495137e1.jpeg";